import React, { useEffect, useMemo, useState } from 'react';
import { api, ApiError } from './api';
import { EstadoError } from './EstadoError';
import './Dashboard.css';

const n = (v) => Number.parseFloat(v || 0);
const fmt = (v) => n(v).toLocaleString('es-AR', { maximumFractionDigits: 3 });

export default function InventariosFisicos() {
  const [lista, setLista] = useState([]);
  const [seleccion, setSeleccion] = useState(null);
  const [detalle, setDetalle] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [soloPendientes, setSoloPendientes] = useState(false);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargarLista = async () => {
    setError('');
    try { setLista(await api.get('/api/inventarios-fisicos')); }
    catch (e) { setError(e instanceof ApiError ? e.mensaje : 'No se pudo cargar el inventario físico.'); }
  };
  const cargarDetalle = async (id) => {
    setError('');
    try {
      const data = await api.get(`/api/inventarios-fisicos/${id}`);
      setSeleccion(id); setDetalle(data);
    } catch (e) { setError(e instanceof ApiError ? e.mensaje : 'No se pudo abrir el conteo.'); }
  };
  useEffect(() => { cargarLista(); }, []);

  const crear = async () => {
    const nombre = window.prompt('Nombre de la toma de inventario:', `Inventario ${new Date().toLocaleDateString('es-AR')}`);
    if (!nombre) return;
    const observaciones = window.prompt('Observaciones (opcional):', '') || '';
    try {
      const data = await api.post('/api/inventarios-fisicos', { nombre, observaciones });
      await cargarLista(); await cargarDetalle(data.id);
    } catch (e) { alert('❌ ' + (e instanceof ApiError ? e.mensaje : 'No se pudo crear.')); }
  };

  const cambiarConteo = (detalleId, valor) => {
    setDetalle(prev => ({ ...prev, detalles: prev.detalles.map(d => d.id === detalleId ? { ...d, cantidad_contada: valor } : d) }));
  };
  const cambiarObs = (detalleId, valor) => {
    setDetalle(prev => ({ ...prev, detalles: prev.detalles.map(d => d.id === detalleId ? { ...d, observacion: valor } : d) }));
  };
  const guardar = async () => {
    if (!detalle) return;
    setGuardando(true);
    try {
      await api.put(`/api/inventarios-fisicos/${detalle.inventario.id}/conteos`, {
        conteos: detalle.detalles.map(d => ({ detalle_id: d.id, cantidad_contada: d.cantidad_contada, observacion: d.observacion || '' }))
      });
      await cargarDetalle(detalle.inventario.id); await cargarLista();
    } catch (e) { alert('❌ ' + (e instanceof ApiError ? e.mensaje : 'No se pudo guardar.')); }
    finally { setGuardando(false); }
  };
  const finalizar = async () => {
    const pendientes = detalle.detalles.filter(d => d.cantidad_contada === null || d.cantidad_contada === '').length;
    if (pendientes) return alert(`Faltan contar ${pendientes} producto(s).`);
    const motivo = window.prompt('Motivo/aprobación del ajuste de stock:', 'Cierre de inventario físico');
    if (!motivo) return;
    if (!window.confirm('Se ajustará el stock real a las cantidades contadas. ¿Continuar?')) return;
    try {
      await guardar();
      const data = await api.post(`/api/inventarios-fisicos/${detalle.inventario.id}/finalizar`, { motivo });
      alert(`✅ Inventario finalizado. Productos ajustados: ${data.ajustes}`);
      await cargarDetalle(detalle.inventario.id); await cargarLista();
      window.dispatchEvent(new CustomEvent('productos-actualizados'));
    } catch (e) { alert('❌ ' + (e instanceof ApiError ? e.mensaje : 'No se pudo finalizar.')); }
  };
  const cancelar = async () => {
    const motivo = window.prompt('Motivo de cancelación:');
    if (!motivo) return;
    try { await api.post(`/api/inventarios-fisicos/${detalle.inventario.id}/cancelar`, { motivo }); await cargarDetalle(detalle.inventario.id); await cargarLista(); }
    catch (e) { alert('❌ ' + (e instanceof ApiError ? e.mensaje : 'No se pudo cancelar.')); }
  };

  const filtrados = useMemo(() => {
    if (!detalle) return [];
    const q = busqueda.trim().toLowerCase();
    return detalle.detalles.filter(d => {
      const codigos = Array.isArray(d.codigos_barras) ? d.codigos_barras.join(' ') : '';
      const coincide = !q || d.descripcion.toLowerCase().includes(q) || String(d.codigo_barras || '').includes(q) || codigos.includes(q);
      const pendiente = d.cantidad_contada === null || d.cantidad_contada === '';
      return coincide && (!soloPendientes || pendiente);
    });
  }, [detalle, busqueda, soloPendientes]);

  if (error) return <EstadoError mensaje={error} onReintentar={seleccion ? () => cargarDetalle(seleccion) : cargarLista} />;

  return <div>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:18,gap:12,flexWrap:'wrap'}}>
      <div><h2 style={{margin:0}}>📋 Inventario físico</h2><p style={{margin:'4px 0',color:'#64748b'}}>Conteo, diferencias y ajuste auditable de stock.</p></div>
      <button onClick={crear} style={btn('#2563eb')}>➕ Nueva toma</button>
    </div>

    {!detalle && <div className="card-panel" style={{overflowX:'auto'}}>
      <table className="table-modern"><thead><tr><th>N°</th><th>Nombre</th><th>Estado</th><th>Avance</th><th>Diferencia</th><th>Fecha</th><th></th></tr></thead>
      <tbody>{lista.map(x => <tr key={x.id}><td>#{x.id}</td><td style={{fontWeight:700}}>{x.nombre}</td><td>{x.estado}</td><td>{x.productos_contados}/{x.total_productos}</td><td>{fmt(x.diferencia_unidades)}</td><td>{new Date(x.creado_en).toLocaleString('es-AR')}</td><td><button onClick={()=>cargarDetalle(x.id)} style={btn('#0f766e')}>Abrir</button></td></tr>)}
      {!lista.length && <tr><td colSpan="7" style={{textAlign:'center',padding:30,color:'#64748b'}}>Todavía no hay tomas de inventario.</td></tr>}</tbody></table>
    </div>}

    {detalle && <>
      <div className="card-panel" style={{marginBottom:15}}>
        <div style={{display:'flex',justifyContent:'space-between',gap:15,flexWrap:'wrap'}}>
          <div><button onClick={()=>{setDetalle(null);setSeleccion(null);}} style={btn('#64748b')}>← Volver</button><h3 style={{margin:'12px 0 4px'}}>#{detalle.inventario.id} · {detalle.inventario.nombre}</h3><span style={{fontWeight:700,color:detalle.inventario.estado==='En conteo'?'#d97706':'#059669'}}>{detalle.inventario.estado}</span></div>
          <div style={{textAlign:'right'}}><div>Contados: <b>{detalle.inventario.productos_contados}/{detalle.inventario.total_productos}</b></div><div>Diferencia teórica: <b>{fmt(detalle.inventario.diferencia_unidades)}</b></div></div>
        </div>
      </div>
      <div style={{display:'flex',gap:10,marginBottom:12,flexWrap:'wrap'}}>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar producto o código" style={{flex:1,minWidth:220,padding:11,border:'1px solid #cbd5e1',borderRadius:8}} />
        <label style={{display:'flex',alignItems:'center',gap:7}}><input type="checkbox" checked={soloPendientes} onChange={e=>setSoloPendientes(e.target.checked)}/> Solo pendientes</label>
        {detalle.inventario.estado==='En conteo' && <><button onClick={guardar} disabled={guardando} style={btn('#2563eb')}>{guardando?'Guardando...':'💾 Guardar conteo'}</button><button onClick={finalizar} style={btn('#059669')}>✅ Finalizar y ajustar</button><button onClick={cancelar} style={btn('#dc2626')}>Cancelar</button></>}
      </div>
      <div className="card-panel" style={{overflowX:'auto'}}><table className="table-modern"><thead><tr><th>Código</th><th>Producto</th><th>Teórico</th><th>Contado</th><th>Diferencia</th><th>Observación</th></tr></thead>
      <tbody>{filtrados.map(d=>{const diff=(d.cantidad_contada===null||d.cantidad_contada==='')?null:n(d.cantidad_contada)-n(d.stock_teorico);return <tr key={d.id}><td>{d.codigo_barras||'-'}</td><td><b>{d.descripcion}</b><div style={{fontSize:11,color:'#64748b'}}>{d.categoria}</div></td><td>{fmt(d.stock_teorico)} {d.unidad_medida}</td><td><input disabled={detalle.inventario.estado!=='En conteo'} type="number" min="0" step={d.acepta_fraccion?'0.001':'1'} value={d.cantidad_contada??''} onChange={e=>cambiarConteo(d.id,e.target.value)} style={{width:105,padding:8,border:'1px solid #cbd5e1',borderRadius:6}}/></td><td style={{fontWeight:700,color:diff===null?'#64748b':diff===0?'#059669':'#dc2626'}}>{diff===null?'-':fmt(diff)}</td><td><input disabled={detalle.inventario.estado!=='En conteo'} value={d.observacion||''} onChange={e=>cambiarObs(d.id,e.target.value)} style={{minWidth:160,padding:8,border:'1px solid #cbd5e1',borderRadius:6}}/></td></tr>})}</tbody></table></div>
    </>}
  </div>;
}

const btn = (bg) => ({background:bg,color:'white',border:'none',borderRadius:7,padding:'9px 13px',fontWeight:700,cursor:'pointer'});
